export default "__VITE_ASSET__de30f9c5__"